import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchAssets } from './features/crypto/cryptoSlice';

function App() {
  const dispatch = useDispatch();
  const assets = useSelector((state) => state.crypto.assets);
  const status = useSelector((state) => state.crypto.status);
  const error = useSelector((state) => state.crypto.error);
  const [selectedAsset, setSelectedAsset] = useState(null);

  useEffect(() => {
    if (status === 'idle') {
      dispatch(fetchAssets());
    }
  }, [status, dispatch]);

  const handleCardClick = (asset) => {
    setSelectedAsset(asset);
  };

  const closeModal = () => {
    setSelectedAsset(null);
  };

  return (
    <div className="App" style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1 style={{ textAlign: 'center' }}>Crypto Price Tracker</h1>

      {status === 'loading' && <p style={{ textAlign: 'center' }}>Loading...</p>}
      {status === 'failed' && <p style={{ textAlign: 'center', color: 'red' }}>Error: {error}</p>}

      {status === 'succeeded' && (
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '20px',
            justifyContent: 'center',
          }}
        >
          {assets.map((asset) => (
            <div
              key={asset.id}
              onClick={() => handleCardClick(asset)}
              style={{
                border: '1px solid #ddd',
                borderRadius: '10px',
                padding: '15px',
                width: '200px',
                textAlign: 'center',
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                backgroundColor: '#fff',
                transition: 'transform 0.2s',
                cursor: 'pointer',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
              onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
            >
              <img
                src={asset.image}
                alt={asset.name}
                width="40"
                height="40"
                style={{ marginBottom: '10px' }}
              />
              <h3 style={{ margin: '5px 0' }}>{asset.name}</h3>
              <p style={{ margin: '5px 0', fontWeight: 'bold' }}>${asset.current_price}</p>
              <p
                style={{
                  margin: '5px 0',
                  color: asset.price_change_percentage_24h > 0 ? 'green' : 'red',
                }}
              >
                {asset.price_change_percentage_24h.toFixed(2)}%
              </p>
            </div>
          ))}
        </div>
      )}

      {/* Modal for selected asset */}
      {selectedAsset && (
        <div
          onClick={closeModal}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            height: '100vh',
            width: '100vw',
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: '#fff',
              borderRadius: '10px',
              padding: '20px',
              width: '300px',
              textAlign: 'center',
              boxShadow: '0 8px 20px rgba(0,0,0,0.2)',
            }}
          >
            <h2>{selectedAsset.name}</h2>
            <img src={selectedAsset.image} alt={selectedAsset.name} width="60" />
            <p><strong>Symbol:</strong> {selectedAsset.symbol.toUpperCase()}</p>
            <p><strong>Current Price:</strong> ${selectedAsset.current_price}</p>
            <p><strong>Market Cap:</strong> ${selectedAsset.market_cap.toLocaleString()}</p>
            <p><strong>24h High:</strong> ${selectedAsset.high_24h}</p>
            <p><strong>24h Low:</strong> ${selectedAsset.low_24h}</p>
            <button
              onClick={closeModal}
              style={{
                marginTop: '10px',
                padding: '8px 16px',
                border: 'none',
                backgroundColor: '#333',
                color: '#fff',
                borderRadius: '5px',
                cursor: 'pointer',
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
